"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalSettings = void 0;
let isServerSideAuthEnabled = false;
let runtimeOptions = {};
let isSSLOrigin = false;
exports.globalSettings = {
    enableServerSideAuth() {
        isServerSideAuthEnabled = true;
    },
    isServerSideAuthEnabled() {
        return isServerSideAuthEnabled;
    },
    setRuntimeOptions(options) {
        // make a copy instead of set the reference
        runtimeOptions = structuredClone(options);
    },
    getRuntimeOptions() {
        return runtimeOptions;
    },
    setIsSSLOrigin(value) {
        isSSLOrigin = value;
    },
    isSSLOrigin() {
        return isSSLOrigin;
    },
};
